﻿import {nanoid} from "@2d-front-monorepo/core";
import { useMemo } from "react";

export function useControlId(id?: string | undefined): string {
	return useMemo(() => id ?? "ctrl-" + nanoid(), [id]);
}
